import type { TypedStoreModule } from "@/types/vuex";

export interface OtherState {
  dataPaymentReport: any,
  currentReportClone: number,
  reportsClone: any[],
  isDragged: boolean,
  panelSettings: any,
  uuidRender: number,
  requestCall: any[],
}

const getters = {
  disabledRequestStats(state: OtherState) {
    if (state.requestCall === undefined) {
      return false;
    }
    return state.requestCall.length !== 0;
  },

  getDataPr(state: OtherState) {
    return state.dataPaymentReport;
  },
}

const mutations = {
  setRequestCall(state: OtherState) {
    if (Array.isArray(state.requestCall)) {
      state.requestCall.push('req');
      return;
    }
    state.requestCall = [];
    state.requestCall.push('req');
  },

  deleteRequestCall(state: OtherState) {
    if (Array.isArray(state.requestCall)) {
      state.requestCall.pop();
    }
  },

  uuidRender(state: OtherState) {
    state.uuidRender = +new Date();
  },

  getSettingsPanel(state: OtherState, payload: any) {
    state.panelSettings = payload;
  },

  DATA_PR: (state: OtherState, payload: any) => {
    state.dataPaymentReport = payload;
  },

  setCurrentReportClone(state: OtherState, payload: number) {
    state.currentReportClone = payload;
  },

  setReportsClone(state: OtherState, payload: any) {
    state.reportsClone = payload;
  },

  isDragged(state: OtherState, payload: boolean) {
    state.isDragged = payload;
  },
};

const storeModule = {
  state: {
    dataPaymentReport: null,
    currentReportClone: 0,
    reportsClone: [],
    isDragged: false,
    panelSettings: {},
    uuidRender: 0,
    requestCall: [],
  } as OtherState,
  getters,
  mutations,
  actions: {},
  namespaced: true,
}

export type OtherModule = TypedStoreModule<'other', typeof storeModule>;

export default storeModule;